import { react_api } from "../config";
import { HTTP_STATUS_CODES } from "../GrinsCostant";

const logout = async (t, clearSessionData, navigate, toast, axiosInstance) => {
  try {
    const richiesta = {
      BearerToken: sessionStorage.getItem("token"),
      username: sessionStorage.getItem("username"),
    };

    const options = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    console.info("Chiamata verso ", `${react_api}`);

    const urlFetch = `${react_api}/logoutADP`;
    const response = await axiosInstance.post(urlFetch, richiesta, options);
    console.info("response: ", response);
    const result = response.data;
    console.info("result: ", result);

    if (result.status === HTTP_STATUS_CODES.BAD_REQUEST || result.status === HTTP_STATUS_CODES.INTERNAL_SERVER_ERROR) {
      toast({
        title: t('toastMsg.error'),
        description: t(`messageBE.${result.message}`),
        position: "top",
        status: 'error',
        duration: 4000,
        isClosable: true,
      });
    }

    if (result.status == HTTP_STATUS_CODES.OK) {
      const toastId = 'session-expired'; // Un ID unico per il toast   
      if (!toast.isActive(toastId)) {
        toast({
          id: toastId,
          title: t('toastMsg.authService.sessionExpired'),
          description: t('toastMsg.authService.yourSessionIsExpiredYouWillBeLoggedOutSoon'),
          position: "top",
          status: 'warning',
          duration: 2300, // Durata del messaggio in millisecondi
          isClosable: true, // Permette di chiudere il toast
          onCloseComplete: () => {
            if (clearSessionData) {
              clearSessionData();
            }else{
              sessionStorage.removeItem('sessionData');
              sessionStorage.removeItem('displayName');
              sessionStorage.removeItem('token');
              sessionStorage.removeItem('messaggio');
              sessionStorage.removeItem('username');
              sessionStorage.removeItem('conteggio');
              sessionStorage.removeItem('loggato');
              sessionStorage.removeItem('role');
            }
            if (navigate) {
              navigate('/home');
            }else{
              window.history.pushState(null, '', '/home');
            }
            window.location.reload();

            // Remove cookies when user logs out using document.cookie
            document.cookie = "essential=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
            document.cookie = "TechnicalGrins=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
          },
        });
      }
    }
  } catch (error) {
    toast({
      title: t('toastMsg.callError'),
      description: String(error),
      position: "top",
      status: 'warning',
      duration: 4000,
      isClosable: true,
    });
  }
};

export default logout;
